<div class="modal-content padding-overwrite h-100">
    <div>
        <h1 class="panel-title position-relative">
            {{data?.msg}}<button type="button" aria-label="Close" class="close" mat-dialog-close>
                <span aria-hidden="true">×</span></button>
        </h1>
    </div>
    <div class="p-3">
        <form [formGroup]="attributeForm" class="d-flex form-area">
            <div *ngFor="let formField of attributeKeyList;let i=index" class="field p-2"
                [ngClass]="excludeReadonlyList.includes(formField)?'':'disabledField'">
                <mat-form-field class="field" *ngIf="checkType(i)==='string'">
                    <mat-label>{{attributeKeyList[i] | titlecase}}</mat-label>
                    <input matInput value="{{ attributeValueList[i] }}" type="text" formControlName="{{formField}}"
                        readonly="{{!excludeReadonlyList.includes(formField)}}">
                </mat-form-field>
                <mat-form-field class="field position-relative" *ngIf="checkType(i)==='object'">
                    <div class="objectLabel cursor" (click)="onObjectDataClick(formField)">
                        {{attributeKeyList[i] | titlecase}}</div>
                    <input matInput value="{{ attributeValueList[i] }}" type="text" formControlName="{{formField}}"
                        readonly="{{!excludeReadonlyList.includes(formField)}}" value="{{ attributeValueList[i] }}">
                </mat-form-field>
                <mat-form-field class="field" *ngIf="checkType(i)==='number'">
                    <mat-label>{{attributeKeyList[i] | titlecase}}</mat-label>
                    <input matInput value="{{ attributeValueList[i] }}" type="number" formControlName="{{formField}}"
                        readonly="{{!excludeReadonlyList.includes(formField)}}">
                </mat-form-field>
                <mat-checkbox class="field checkbox-width" [checked]="attributeValueList[i]"
                    formControlName="{{formField}}" [disabled]="!excludeReadonlyList.includes(formField)"
                    *ngIf="checkType(i)==='boolean'">
                    {{attributeKeyList[i] | titlecase}}
                </mat-checkbox>
            </div>
        </form>
    </div>
    <div class="btn-basket">
        <button mat-button mat-dialog-close
            class="mat-focus-indicator mat-raised-button mat-button-base mat-primary">Cancel</button>
        <button mat-button (click)="submit()"
            class="mat-focus-indicator mat-raised-button mat-button-base mat-primary">Submit</button>
    </div>
</div>